import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import {
  useId,
//   Button,
//   Field,
//   RadioGroup,
//   Radio,
  Toaster,
  useToastController,
//   ToastPosition,
  ToastTitle,
  Toast,
  Spinner,
//   Dropdown,
//   Option,
  Select
} from "@fluentui/react-components";

 const useStyles = makeStyles({
    wrapper: {
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f8fcff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        // padding: "0 15px",
        margin: 0,
        width: "100%"
    },
    parserWrapper: {
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f8fcff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        // height: "500vh",
        margin: 0,
        // top: "50%"
    },
    loginContainer: {
        textAlign: "left",
        maxWidth: "300px",
        width: "100%"
    },
    logo: {
        width: "70px",
        height: "auto"
    },
    title: {
        fontSize: "28px",
        fontWeight: "bold",
        marginTop: "10px"
    },
    subTitle: {
        fontSize: "16px",
        color: "#555",
        marginBottom: "40px",
        marginTop: "10px"
    },
    emailInput: {
        width: "calc(100% - 24px)",
        padding: "12px",
        fontSize: "16px",
        marginBottom: "20px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        '&:focus': {
            outline: "none"        
        }, 
    },
    selectField: {
        width: "100%",
        padding: "12px",
        fontSize: "16px",
        marginBottom: "20px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        backgroundColor: "#ffffff"
    },
    // selectInnerField: {
    //     border: "none",
    //     backgroundColor: "red"
    // },
    btnNext: {
        backgroundColor: "#1a4ed8",
        color: "white",
        border: "none",
        padding: "12px 24px",
        fontSize: "16px",
        borderRadius: "4px",
        cursor: "pointer",
        display: "block",
        marginLeft: "auto"
    },
    helpLink: {
        position: "absolute",
        right: "20px",
        bottom: "20px",
        display: "block",
        marginTop: "40px",
        textAlign: "right",
        color: "#888",
        fontSize: "14px",
        textDecoration: "none"
    },
    // help-link:hover: {
    //     textDecoration: "underline"
    // },
    emailDisplay: {
      display: "flex",
      alignItems: "center",
      background: "white",
      padding: "12px",
      border: "1px solid #ccc",
      borderRadius: "25px",
      fontSize: "15px",
      marginBottom: "20px"
    },
    emailDisplaySpan: {
    //   margin: "0 8px",
      margin: "0 6px 0 0",
      flexGrow: 1
    },
    formField: {
        // width: "100%",
        width: "calc(100% - 24px)",
        padding: "12px",
        fontSize: "16px",
        marginBottom: "20px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        '&:focus': {
            outline: "none"        
        },        
    },
    loginButton: {
      backgroundColor: "#1a4ed8",
      color: "white",
      border: "none",
      padding: "12px 24px",
      fontSize: "16px",
      borderRadius: "5px",
      cursor: "pointer",
      marginTop: "10px",
      display: "block",
      marginLeft: "auto"
    },
    icon: {
      fontSize: "16px"
    },
    header: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "20px 40px",
      maxWidth: "300px",
      marginTop: "20px",
      marginBottom: "150px"
    },
    logo: {
      height: "60px"
    },
    username: {
      fontSize: "20px",
      fontWeight: "bold",
    //   flexGrow: 1,
      textAlign: "center"
    },
    signoutButton: {
      backgroundColor: "#1a4ed8",
      color: "white",
      border: "none",
      padding: "10px 20px",
      fontSize: "16px",
      borderRadius: "6px",
      cursor: "pointer"
    }
    // select: {
    //     border: "none !important",
    //     padding: "0 !important"
    // }
});

export default function AuthProvider({children,logout,setLogout}){

    const OutlookParsing = children;

    const [email,setEmail] = React.useState("");
    const [isValidUser,setIsValidUser] = React.useState(false);
    const [nextDisable,setNextDisable] = React.useState(false);
    const [loginDisable,setLoginDisable] = React.useState(false);
    const [orgs,setOrgs] = React.useState([]);
    const [orgSelect,setOrgSelect] = React.useState('');
    const [password,setPassword] = React.useState('');
    const dropdownId = useId("organization-dropdown");

    const [ehAuthToken,setEhAuthToken] = React.useState(Office.context.roamingSettings.get("ehAuthToken"));
    const [ehLoggedInUser,setEhLoggedInUser] = React.useState(Office.context.roamingSettings.get("ehLoggedInUser"));
    
    const toasterId = useId("toaster");
    const { dispatchToast, dismissAllToasts } = useToastController(toasterId);
    const [position, setPosition] = React.useState("bottom");
    const notify = (msg,intent) => {
        switch (intent) {
            case "progress" : 
                dispatchToast(
                    <Toast>
                        <ToastTitle media={<Spinner size="tiny" />}>{msg}</ToastTitle>
                    </Toast>,
                    { position, intent: intent, timeout:-1}
                );
                break;
            case "error":
            case "info":
            case "success":
            case "warning":
                dispatchToast(
                    <Toast>
                        <ToastTitle>{msg}</ToastTitle>
                    </Toast>,
             
             { position, intent: intent }
                );
                break;
        }
    }
        

    const styles = useStyles();

    const validateUser = () => {
        
        if(!isValidEmail(email)){
            notify('Please enter a valid email','warning');
        }else{
            setNextDisable(true);
            notify('Validating User...','progress');
            var respone = fetch('https://admin-api.excelhire.com/api/check_user_name',{
                method: 'post',
                body: JSON.stringify({
                    "email": email
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(reponse => reponse.json())
            .then(user => {
                setNextDisable(false);
                dismissAllToasts();

                if(user?.data?.verfied == false){
                    notify('Couldn\'t find your account.','error');
                }else{
                    notify('Email validated successfully.','success');
                    setIsValidUser(true);
                }

                setOrgs(user?.data?.organizations);

                if(user?.data?.organizations.length == 1){
                    setOrgSelect(user?.data?.organizations[0]._id)
                }
            });
        }
        
    }

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const isValidEmail = (email) => {
        var email = email.trim();

        // Basic email validation regex
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email)) {
            return false;
        }
        return true;
    }

    const handleOrgChange = (e) => {
        setOrgSelect(e.target.value)
    }

    const handlePassChange = (e) => {
        setPassword(e.target.value);
    }

    const authenticateUser = () => {
        setLoginDisable(true);
        // console.log(email);
        // console.log(password);
        // console.log(orgSelect);

        notify('Attempting login...','progress');

        if(email == ""){
            dismissAllToasts();
            notify('Please enter a email','warning');
            setLoginDisable(false);
            return;
        }

        if(orgSelect == "" || orgSelect == "Select a Organization"){
            dismissAllToasts();
            notify('No organisation selected','warning');
            setLoginDisable(false);
            return;
        }

        if(password == ""){
            dismissAllToasts();
            notify('Please enter a password','warning');
            setLoginDisable(false);
            return;
        }

        fetch('https://admin-api.excelhire.com/api/login',{
            method:"post",
            body:JSON.stringify({
                "email": email,
                "password": password,
                "organization_id": orgSelect
            }),
            headers:{
                "Content-Type" : "application/json"
            }
        })
        .then(response => response.json())
        .then(loginStatus => {
            console.log(loginStatus)

            dismissAllToasts();

            if(loginStatus.hasOwnProperty('error')){
                setLoginDisable(false);
                notify(loginStatus.error,'error');
            }else if(loginStatus.hasOwnProperty('message')){
                setLoginDisable(false);
                notify(loginStatus.message,'error');
            }else{
                notify("Logged in successfully",'success');
                
                var fullName = `${loginStatus.data.first_name} ${loginStatus.data.last_name}`;
                setEhLoggedInUser(fullName);
                storeUserLocally('ehLoggedInUser',fullName);

                var x_auth_token = loginStatus.data.x_auth_token;
                setEhAuthToken(x_auth_token);
                storeUserLocally('ehAuthToken',x_auth_token);
            }
        })
        .catch((error) => {
            dismissAllToasts();
            console.error(error)
            notify(error,'error');
            setLoginDisable(false);
        });

    }

    const storeUserLocally = (key,value) => {
        Office.context.roamingSettings.set(key, value);
        Office.context.roamingSettings.saveAsync();
    }

    const signOut = () => {
        notify('Singing out...','progress');
        fetch("https://admin-api.excelhire.com/api/organization_user/signout",{
            method: 'post',
            body:'{}',
            headers:{
                "Content-Type":"application/json",
                "x-auth-token": Office.context.roamingSettings.get("ehAuthToken")
            }
        })
        .then(resp => resp.json())
        .then(signout => {
            dismissAllToasts();
            notify('Logout succesfully','success');
            clearUserData();
        })
    }

    const clearUserData = () => {
        Office.context.roamingSettings.remove("ehAuthToken");
        Office.context.roamingSettings.remove("ehLoggedInUser");
        Office.context.roamingSettings.remove("ehAccessToken");
        Office.context.roamingSettings.saveAsync();
        setEhAuthToken("");
        setEhLoggedInUser("");
        setEmail("");
        setOrgSelect("");
        setPassword("");
        setIsValidUser(false);
        setLoginDisable(false);
        setNextDisable(false);
    }

    

    React.useEffect(()=>{
        if(logout){
            clearUserData();
            setLogout(false)
        }
    },[logout])
    
    return (
        <>
            {
                ehAuthToken ?
                    <>
                        <div className={styles.header}>
                            <img className={styles.logo} src="assets/logo.png" alt="Excelhire Logo" />
                            <div className={styles.username}>{ehLoggedInUser}</div>
                            <button className={styles.signoutButton} onClick={signOut}>Sign Out</button>
                        </div>
                        <div className={styles.parserWrapper}>
                            {OutlookParsing}
                        </div>
                        <a target="_blank" className={styles.helpLink} href="https://excelhire.us/">Need help?</a>
                    </>
                :
                <div className={styles.wrapper}>
                    <div className={styles.loginContainer}>
                        <img className={styles.logo} src="assets/logo.png" alt="EX Logo" />
                        <div className={styles.title}>Sign in</div>
                        <div className={styles.subTitle}>with your Excelhire account</div>

                        {!isValidUser ? 
                            <>
                                <input onChange={handleEmailChange} className={styles.emailInput} type="email" placeholder="Enter Email Address..." value={email} />
                                <br />
                                <button type="submit" className={styles.btnNext} onClick={validateUser} disabled={nextDisable ? 'disabled' : ''}>Next</button>
                            </>
                            : 
                            <>
                                <div className={styles.emailDisplay}>
                                    {/* <span className={`${styles.icon} ${styles.emailDisplaySpan}`}>📧</span> */}
                                    <span className={`${styles.icon} ${styles.emailDisplaySpan}`} onClick={()=>setIsValidUser(false)}>✏️</span>
                                    <span className={styles.emailDisplaySpan}>bhadiyadrapratik007@gmail.com</span>
                                    
                                </div>

                                {orgs.length > 1 && 
                                    <select onChange={handleOrgChange} className={styles.selectField}>
                                        <option>Select a Organization</option>
                                        {orgs.map((org) => (
                                            <option className={styles.selectInnerField}  key={org['_id']} value={org['_id']}>
                                                {org.organization_name}
                                            </option>
                                        ))}
                                    </select>
                                }

                                <input className={styles.formField} type="password" placeholder="Password" onChange={handlePassChange}/>
                                <button className={styles.loginButton} onClick={authenticateUser} disabled={loginDisable ? 'disabled' : ''}>Login</button>
                            </>
                        }
                    <a target="_blank" className={styles.helpLink} href="https://excelhire.us/">Need help?</a>
                    </div>
                </div>
            }
            <Toaster inline toasterId={toasterId} />
        </>
        
    )
}